import {Component, Input, OnInit} from '@angular/core';
import {OzonBericht} from "../../../../../../../model/vorhersagen/radiobremen-wetterbericht";

@Component({
  selector: 'app-radiobremen-spezial-bericht',
  templateUrl: './radiobremen-spezial-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class RadiobremenSpezialBerichtComponent  {
  @Input() spezialBericht: string;


}
